import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { ReturnedOrder } from "@assets/svg/MyDeliveries";
import { colors } from "@constants/theme";
import t from "@constants/localization";

const PATH = "screens/MyDeliveries/components/ReturnProductInfoCard";

const ReturnProductInfoCard = ({ data }) => {
  const isShowCard = data?.some((item) => item?.returnDetails);

  if (isShowCard) {
    return (
      <View style={styles.container}>
        <ReturnedOrder />
        <View style={styles.textContainer}>
          <Text style={styles.title}>{t(`${PATH}/title`)}</Text>
          <Text style={styles.desc}>{t(`${PATH}/desc`)}</Text>
        </View>
      </View>
    );
  }
  return <></>;
};

export default ReturnProductInfoCard;

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: "rgba(255, 46, 0, 0.08)",
    borderRadius: 10,
    marginHorizontal: 16,
    flexDirection: "row",
    overflow: "hidden",
    marginTop: 16,
  },
  textContainer: {
    marginHorizontal: 16,
  },
  title: { fontSize: 14, fontFamily: "NotoSansDevanagari-Bold" },
  desc: {
    fontSize: 12,
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
    marginRight: "25%",
  },
});
